// Shared helpers for the "dealer must assign a receiver within 2 days" rule.
// The server sends receiver_deadline / receiver_locked / receiver_required on
// each vehicle; these helpers turn that into UI state (countdown text, badge).

export function getReceiverStatus(vehicle) {
    if (!vehicle) return { required: false, locked: false, deadline: null, msLeft: 0 };
    const deadline = vehicle.receiver_deadline ? new Date(vehicle.receiver_deadline) : null;
    const required = !!vehicle.receiver_required;
    const locked = !!vehicle.receiver_locked;
    const msLeft = deadline ? deadline.getTime() - Date.now() : 0;
    return { required, locked, deadline, msLeft };
}

// Human-readable time left, e.g. "1 დღე 4 სთ" / "5 სთ" / "ვადა ამოიწურა".
export function formatTimeLeft(msLeft, t) {
    if (msLeft <= 0) return t ? t("vehicles.receiverExpired") : "expired";
    const totalMinutes = Math.floor(msLeft / 60000);
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;
    const dLabel = t ? t("vehicles.unitDay") : "d";
    const hLabel = t ? t("vehicles.unitHour") : "h";
    const mLabel = t ? t("vehicles.unitMinute") : "m";
    if (days > 0) return `${days} ${dLabel} ${hours} ${hLabel}`;
    if (hours > 0) return `${hours} ${hLabel} ${minutes} ${mLabel}`;
    return `${minutes} ${mLabel}`;
}
